// extracted by mini-css-extract-plugin
export default {"overlay":"BlankScreen_overlay__8Q6HQ"};